import { render, staticRenderFns } from "./HeaderIconSocialGrouped.vue?vue&type=template&id=a65a0664&"
import script from "./HeaderIconSocialGrouped.vue?vue&type=script&lang=js&"
export * from "./HeaderIconSocialGrouped.vue?vue&type=script&lang=js&"
import style0 from "./HeaderIconSocialGrouped.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a65a0664')) {
      api.createRecord('a65a0664', component.options)
    } else {
      api.reload('a65a0664', component.options)
    }
    module.hot.accept("./HeaderIconSocialGrouped.vue?vue&type=template&id=a65a0664&", function () {
      api.rerender('a65a0664', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/HeaderIconSocialGrouped.vue"
export default component.exports